import { useQuery } from '@tanstack/react-query'
import { lookupQueryKeys } from './useRocketReachLookup'

/**
 * Simple reactive state hook for contact lookup data
 * @param {string} contactId - The contact ID to track state for
 * @returns {object} - Reactive state for the contact lookup data
 */
const useContactLookupState = contactId => {
  // Reactive query hooks for tracking state only
  const { data: lookupData, isFetching } = useQuery({
    queryKey: lookupQueryKeys.contactLookup(contactId),
    select: data => data?.data,
    enabled: false, // Don't use for fetching, just track state
  })

  return {
    hasLookupData: Boolean(lookupData),
    isFetching,
    lookupData,
  }
}

export default useContactLookupState
